/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-03-03 19:12:58
 */
/*
 * 权益对比表：用于升级弹窗中展示各会员等级在「重复照片删除」上的权益差异
 * 遵循 UI 规范：表格清晰、图标统一使用 antd Icon、当前等级高亮、足够对比度
 */
import React from 'react'

import './PrivilegeCompareTable.scss'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'

export type PrivilegeTierKey = 'nonVip' | 'vip' | 'svipVvip'

const COLUMNS: { key: PrivilegeTierKey; label: string }[] = [
  { key: 'nonVip', label: '非会员' },
  { key: 'vip', label: 'VIP' },
  { key: 'svipVvip', label: 'VVIP / SVIP' }
]

const ROWS: {
  label: string
  nonVip: boolean
  vip: boolean
  svipVvip: boolean
}[] = [
  { label: '相似检测', nonVip: true, vip: true, svipVvip: true },
  { label: '结果预览', nonVip: true, vip: true, svipVvip: true },
  { label: '筛选找图', nonVip: true, vip: true, svipVvip: true },
  { label: '单张删除', nonVip: false, vip: true, svipVvip: true },
  { label: '按组多选删', nonVip: false, vip: false, svipVvip: true },
  { label: '全选批量删', nonVip: false, vip: false, svipVvip: true }
]

export interface PrivilegeCompareTableProps {
  /** 当前用户所在等级，用于高亮该列并显示「当前」角标 */
  currentTier: PrivilegeTierKey
}

const PrivilegeCompareTable: React.FC<PrivilegeCompareTableProps> = ({
  currentTier
}) => {
  return (
    <div
      className="privilege-compare-table"
      role="table"
      aria-label="各会员等级在重复照片删除上的权益对比"
    >
      <div className="privilege-compare-table__header" role="row">
        <div
          className="privilege-compare-table__cell privilege-compare-table__cell--th"
          role="columnheader"
        >
          权益
        </div>
        {COLUMNS.map((col) => (
          <div
            key={col.key}
            className={`privilege-compare-table__cell privilege-compare-table__cell--th ${
              currentTier === col.key
                ? 'privilege-compare-table__cell--current'
                : ''
            }`}
            role="columnheader"
          >
            <span className="privilege-compare-table__th-label">
              {col.label}
            </span>
          </div>
        ))}
      </div>
      {ROWS.map((row, rowIndex) => (
        <div key={rowIndex} className="privilege-compare-table__row" role="row">
          <div
            className="privilege-compare-table__cell privilege-compare-table__cell--label"
            role="cell"
          >
            {row.label}
          </div>
          {COLUMNS.map((col) => {
            const hasPrivilege = row[col.key]
            return (
              <div
                key={col.key}
                className={`privilege-compare-table__cell privilege-compare-table__cell--value ${
                  currentTier === col.key
                    ? 'privilege-compare-table__cell--current'
                    : ''
                }`}
                role="cell"
              >
                {hasPrivilege ? (
                  <CheckCircleOutlined
                    className="privilege-compare-table__icon privilege-compare-table__icon--yes"
                    aria-hidden
                  />
                ) : (
                  <CloseCircleOutlined
                    className="privilege-compare-table__icon privilege-compare-table__icon--no"
                    aria-hidden
                  />
                )}
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}

export default PrivilegeCompareTable
